export default "__VITE_ASSET__DXA9kYVh__"